'use client';
import { UserContext } from './auth-context';
import { useContext } from 'react';

// Hook for easy context usage
export const useAuth = () => useContext(UserContext);
